'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconLightningBolt, iconLightningBoltTag } from '@ni/nimble-components/dist/esm/icons/lightning-bolt';
import { wrap } from '../../utilities/react-wrapper';

export type { IconLightningBolt };
export { iconLightningBoltTag };
export const NimbleIconLightningBolt = wrap(IconLightningBolt);